import { render, staticRenderFns } from "./XrImport.vue?vue&type=template&id=d2dc44a4&scoped=true"
import script from "./XrImport.vue?vue&type=script&lang=js"
export * from "./XrImport.vue?vue&type=script&lang=js"
import style0 from "./XrImport.vue?vue&type=style&index=0&id=d2dc44a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2dc44a4",
  null
  
)

export default component.exports